import React from 'react'
import PropTypes from 'prop-types'

import { Flex, Image } from '@chatterbug/aaron'

import { goldenStar, greyStar, halfStar } from './assets'

const Rating = ({ rating = 0, numOfStars = 5 }) => {
  // check that rating is not higher than available stars
  const maxRating = Math.min(rating, numOfStars)
  const rounded = Math.floor(maxRating)
  const isFraction = maxRating !== rounded

  return (
    <Flex>
      {[...Array(rounded)].map((_, index) => (
        <Image src={goldenStar} key={`golden-star-${index}`} />
      ))}
      {isFraction && <Image src={halfStar} key={`golden-star-${rounded}`} />}
      {[...Array(numOfStars - (isFraction ? rounded + 1 : rounded))].map(
        (_, index) => (
          <Image src={greyStar} key={`grey-star-${index}`} />
        )
      )}
    </Flex>
  )
}

Rating.propTypes = {
  rating: PropTypes.number,
  numOfStars: PropTypes.number,
}

export default Rating
